<template>

    <div>

        <el-dialog title="考评记录" width="80%" :visible="kpiDialogVisible" @close="close" center>
            <el-form :model="form_kpi_record" ref="form_kpi_record" label-width="85px" class="demo-ruleForm"
                     :rules="rule_record">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="姓名" prop="username">

                            <el-select :disabled="allowChangeUser" class="width100" v-model="form_kpi_record.username" clearable filterable
                                       placeholder="请选择员工" size="small">
                                <el-option
                                        v-for="item in kpiPersonList"
                                        :key="item.personid"
                                        :label="item.realName"
                                        :value="item.personid">
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="绩效分" prop="score">
                            <el-input v-model="form_kpi_record.score" @input.native="handleScoreInput"
                                      size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="考评内容" prop="content">
                            <el-input type="textarea" :rows="6" v-model="form_kpi_record.content"
                                      size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="考评结果" prop="result">
                            <el-input type="textarea" :rows="6" v-model="form_kpi_record.result"
                                      size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="附件">
                            <el-upload
                                    ref="upload"
                                    :http-request="prepareFiles"
                                    :before-remove="beforeRemove"
                                    :on-preview="handlePreview"
                                    :before-upload="beforeAvatarUpload"
                                    :on-remove="handleRemove"
                                    :file-list="downLoadFileArr"
                                    multiple>
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                <div slot="tip" class="el-upload__tip">附件大小不允许超过5MB</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row style="text-align: center">
                    <el-button center="true" type="primary" @click="save">确 定</el-button>
                    <el-button center @click="close">关 闭</el-button>
                </el-row>

            </el-form>
        </el-dialog>

    </div>

</template>


<script>

    import KpiServer from '@/api/kpi/index'
    import Attachment from '@/components/attachment'
    import AttachmentServer from '../../api/attachment'

    export default {

        name: "KpiRecordDialog",

        props: ['kpiDialogVisible', 'kpiRecordInfo', 'kpiPersonList'],

        components: {
            Attachment,
        },

        data() {
            return {

                ownerTable: 'KPI',

                docType: 'KPI',

                uploadFileArr: [],

                downLoadFileArr: [],

                attachmentMaxSize: 5,

                canSaveFlag: true,

                allowChangeUser: false,  //是否允许变更用户（新建允许、修改不允许）

                form_kpi_record: {
                    username: '',
                    realname: '',
                    kpiDto: {
                        kpino: '',
                        deptid: 0,
                    },
                    content: '',
                    result: '',
                    score: 0,
                    changeby: localStorage.getItem("username"),
                },

                rule_record: {
                    username: [
                        {
                            required: true,
                            trigger: 'blur',
                            message: '请选择姓名',
                        }
                    ],
                    score: [
                        {
                            required: true,
                            trigger: 'blur',
                            message: '请输入绩效分',
                        }
                    ],
                    content: [
                        {
                            required: true,
                            trigger: 'blur',
                            message: '请输入考评内容',
                        },
                        {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur'}
                    ]
                },

            }
        },

        methods: {

            initFormData() {
                this.form_kpi_record.username = '';
                this.form_kpi_record.realname = '';
                this.form_kpi_record.content = '';
                this.form_kpi_record.result = '';
                this.form_kpi_record.score = '';

                this.downLoadFileArr = [];
            },

            queryKpiRecordDetail(id) {
                let that = this;
                KpiServer.kpiRecord.get(id).then((responseBody) => {
                    if (responseBody.data && responseBody.data.data) {
                        this.form_kpi_record = responseBody.data.data;
                        let params = {
                            ownerTable: 'KPI',
                            ownerId: id,
                        }
                        AttachmentServer.attachment.downloadList(params).then(responseBody => {
                            that.downLoadFileArr = responseBody;
                        });
                    }
                }).catch(error => {
                    this.$message.error(error);
                });
            },

            save() {
                this.$refs['form_kpi_record'].validate((valid) => {
                    if (!valid) {
                        return;
                    } else {
                        if (this.kpiRecordInfo.id == null) {
                            this.form_kpi_record['kpiDto'] = this.kpiRecordInfo.kpiDto;
                            KpiServer.kpiRecord.add(this.form_kpi_record).then(responseBody => {
                                this.kpiRecordInfo.id = responseBody.data.data;
                                this.form_kpi_record.id = responseBody.data.data;
                                this.$message.success('考评记录添加成功');

                                this.uploadFile();
                            });
                        } else {
                            this.form_kpi_record['kpiDto'] = this.kpiRecordInfo.kpiDto;
                            KpiServer.kpiRecord.update(this.form_kpi_record.id, this.form_kpi_record).then(responseBody => {
                                this.$message.success('考评记录更新成功');
                                this.uploadFile();
                            });
                        }
                    }
                });
            },

            prepareFiles(e) {
                this.uploadFileArr.push(e.file);
            },

            async uploadFile() {
                for (let i = 0; i < this.uploadFileArr.length; i++) {
                    let params = {
                        file: this.uploadFileArr[i],
                        ownerTable: this.ownerTable,
                        docType: this.docType,
                        ownerId: this.form_kpi_record.id,
                    }
                    await AttachmentServer.attachment.upload(params);
                }
                await this.downloadList(this.ownerTable, this.form_kpi_record.id);
                this.uploadFileArr = [];
                this.$emit("afterSavedKpiRecord");
            },

            downloadList(ownerTable, ownerId) {
                let params = {ownerTable, ownerId};
                AttachmentServer.attachment.downloadList(params).then(responseBody => {
                    this.downLoadFileArr = responseBody;
                });
            },

            close() {
                this.$emit('update:kpiDialogVisible', false);
            },

            handleScoreInput(e) {
                let target = (e.target.value.match(/^-?\d*(\.?\d{0,1})/g));
                this.form_kpi_record.score = target[0];
            },

            handlePreview(file) {
                console.log(file);
            },

            beforeRemove(file) {
                if (this.canSaveFlag == true) { //仅在文件不大于5M且可以上传的情况下，删除时需要提示此信息
                    return this.$confirm(`确定移除 ${file.name}？`);
                }
            },

            handleRemove(file, fileList) {
                AttachmentServer.attachment.delete(file.docLinkSid).then(responseBody => {
                    this.$message("删除成功");
                });
            },

            beforeAvatarUpload(file) {
                const sizeIsValid = file.size <= this.attachmentMaxSize * 1024 * 1024;
                if (!sizeIsValid) {
                    this.$message.error(`附件大小不允许超过${this.attachmentMaxSize}MB!`);
                    this.canSaveFlag = false;
                } else {
                    this.canSaveFlag = true;
                }
                return sizeIsValid;
            },

        },

        watch: {
            kpiRecordInfo: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    try {
                        this.$refs['form_kpi_record'].resetFields();
                    } catch (e) {

                    }
                    if (newVal.id != null) {
                        try {
                            this.$refs['form_kpi_record'].clearValidate();
                        } catch (e) {
                            console.log(e.toString());
                        }
                        this.allowChangeUser = true;
                        this.queryKpiRecordDetail(newVal.id);
                    } else {
                        this.queryKpiRecordDetail(-1);
                        this.allowChangeUser = false;
                    }
                }
            },
        },


    }

</script>